import { IconHighDemand16, IconProductCianLogo12 } from '@cian/ui-kit';
import * as React from 'react';

import { ELabelColor, TLabelColor } from '../../types/label';

export const labelIconMap: Record<ELabelColor, React.ReactElement | undefined> = {
  [ELabelColor.Red]: undefined,
  [ELabelColor.Green]: undefined,
  [ELabelColor.Blue]: <IconProductCianLogo12 color="current_color" />,
  [ELabelColor.Gray]: undefined,
  [ELabelColor.DarkGray]: undefined,
  [ELabelColor.Yellow]: undefined,
  [ELabelColor.SimpleBlue]: undefined,
  [ELabelColor.DarkBlue]: undefined,
  [ELabelColor.BlackBlueGradient]: undefined,
  [ELabelColor.Purple]: <IconHighDemand16 color="current_color" />,
};

export function mapLabelIcon(color: TLabelColor): React.ReactElement | undefined {
  return labelIconMap[color];
}
